// extracted by mini-css-extract-plugin
export default {"detailsContainer":"MovieDetails_detailsContainer__YD8iL","carta":"MovieDetails_carta__DVJL8","col":"MovieDetails_col__Czcf9","movieText":"MovieDetails_movieText__wjOYI"};